import { Component, ViewChild, ElementRef, OnDestroy, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CorrectedHttpClient } from '../_infrastructure/http/corrected-http-client'
import { ActivatedRoute, Router, ParamMap, NavigationExtras } from '@angular/router';
import { map, mergeMap, switchMap, filter, tap, catchError } from 'rxjs/operators';
import { Subject, ReplaySubject, Observable, Subscription, of, throwError, combineLatest } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { StepComponent } from './step.component';
import { AlertService } from '../_infrastructure/Alerts/alert.service';
import { StepStateCodes } from "../../models/const.Contants";
import { NgForm } from '@angular/forms';
import { ExternalValidationsService } from '../_infrastructure/ValidationMessages/ExternalValidationsService';
import { PermissionConstants } from '../../models/const.PermissionConstants';
import { BsLocaleService } from 'ngx-bootstrap/datepicker'
import { defineLocale } from 'ngx-bootstrap/chronos';
import { ptBrLocale } from 'ngx-bootstrap/locale';
import { ModalService } from '../_infrastructure/Modal/ModalService';
import { VisualActions } from "../../models/const.Contants";
import { SystemInformationService } from '../_infrastructure/SystemInformation/SystemInformationService';
import { SecurityService } from '../_infrastructure/Security/SecurityService';
import { isNullOrUndefined } from '../_infrastructure/objectUtils';
import { LoadingMaskService } from '../_infrastructure/LoadingMask/LoadingMaskService';
import { StepDetailsService } from '../_infrastructure/StepDetailsService/StepDetailsService';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LogType } from '../../models/const.LogModelVM';
import { LogService } from '../_infrastructure/log/LogService';
import { CacheService } from '../_infrastructure/Cache/CacheService';
import { DocumentVMExtension } from './cards/Documentation/IDocumentation';
import { SessionStorageService } from '../_infrastructure/SessionStorageService/SessionStorageService';

@Component({
    selector: 'workflow',
    templateUrl: './workflow.component.html',
    styleUrls: ['./workflow.component.scss'],
    standalone: false
})
export class WorkflowComponent implements OnDestroy {

  @ViewChild('errorsFound') errorsFound: TemplateRef<any>;
  modalRef: BsModalRef;

  ngOnInit() {

    // PIT 40803 \\
    const validOption = ['/instancebrowser', '/workflowSearch'];

    const dadosOrigem = this.sessionStorageService.getOrigemPedidoOptionOnCache();

    if (dadosOrigem != null && validOption.includes(dadosOrigem.origemDoAcesso)) {
      this.destinoRouter = dadosOrigem.origemDoAcesso;
    }
    else {
      this.destinoRouter = '/workflowSearch';
    }
    // PIT 40803 \\
  }


  public destinoRouter: string;
  public cardData: models.SendWorkflowVM = {} as models.SendWorkflowVM;
  public lastCurrentStep: string;
  public isReturn: boolean = false;
  public isDisabled: boolean = false;
  public iCanAccess: boolean = true;
  public workflowInstanceLoaded: boolean = false;
  readonly VisualActions = VisualActions;
  //BUSINESS
  public domain: string;
  public currentStep: StepComponent;
  public workflowInstanceId: string; // Recebido da rota
  public steps: models.StepVM[] = [];
  public workflowTemplate: models.WorkflowTemplateVM = {} as models.WorkflowTemplateVM;
  public workflowInstance: models.WorkflowInstanceVM = {} as models.WorkflowInstanceVM;
  public workFlowErrors: models.WorkflowValidationsVM = {} as models.WorkflowValidationsVM;
  public showReturnButton: boolean;
  public mainSubscription: Subscription = new Subscription();
  public workflowDropdowns: models.WorkflowDropdownsVM = {} as models.WorkflowDropdownsVM;
  //public workflowMandatoryDocs: models.DocumentVM[] = [];
  public workflowVersion: any[];

  public isAtendimento: boolean;
  public nextMenuStep: string;
  public canApagarCTO: boolean = false;
  public isServico: boolean;
  public sOrigem: number;
  public isNSI: boolean = false;
  //NAVIGATION
  public currentStepIndex = 0;
  public get currentPercentage() { return this.currentStepIndex != 0 ? 1 - (this.currentStepIndex / this.steps.length) : 1 };
  public get isLastStep() {
    return this.currentStepIndex >= this.steps.length - 1;
  }
  public get isFirstStep() {
    return ((this.currentStepIndex) || 0) <= 0;
  }
  public get isNextDisabled() {
    return this.isDisabled ;
  }

  public get isCurrentStepLoaded() {
    return this.currentStep?.isStepLoaded;
  }

  public get currentStepDefinition(): models.StepVM {
    return this.steps[this.currentStepIndex];
  }

  public get isWorkflowSubmited() {
    return this.workflowInstance?.stateCode === "C";
  }

  public get isWorkflowOnSubscriber() {
    if (this.isAtendimento)
      return this.workflowInstance.instanceRole == '007' ? true : false;
    else
      return this.securityService.userHasPermission(PermissionConstants.WorkflowEditPage.editSubscriberData);
  }

  public get isWorkflowPgpv() {
    return this.securityService.isUserPgpv();
  }

  public get canUserSaveData() {
    return this.securityService.canUserSaveData();
  }

  @ViewChild('cgaWorkflowForm')
  private cgaWorkflowForm: NgForm;
  
  @ViewChild('cgaGetFileForm', { read: ElementRef }) cgaGetFileForm: ElementRef;

  private _initialized: Subject<void> = new ReplaySubject<void>();
  // Esta propriedade serve para os steps filhos terem uma guarda que lhes permita saber se o pai já carregou os dados
  public get initialized(): Observable<void> {
    return this._initialized.asObservable();
  }

  constructor(private localeService: BsLocaleService, private http: CorrectedHttpClient, private activeRoute: ActivatedRoute, private router: Router, private alertService: AlertService,
    private translate: TranslateService, private externalValidationsService: ExternalValidationsService, private modalService: ModalService, private bsModalService: BsModalService,
    private systemInformationService: SystemInformationService, private securityService: SecurityService,
    private loadingMaskService: LoadingMaskService, private stepDetailsService: StepDetailsService, private logService: LogService, private cacheService: CacheService,
    private sessionStorageService: SessionStorageService  ) {
    this.activeRoute.paramMap.subscribe((params: ParamMap) => {
      this.workflowInstanceId = params.get('workflowInstanceId');

      if (this.workflowInstanceId !== undefined) {
        this.loadingMaskService.setShowLoading(true, true,null);

        this.isAtendimento = ((this.securityService.userDetails.informationGroups.includes("PGPA") ? "A" : null) == "A" ? true : false);
        this.isServico = (this.securityService.userDetails.informationGroups.includes("PGPS") ? true : false);

        this.http.get('api/Workflow/ValidaOrigemMGPA', { params: { workflowInstanceID: this.workflowInstanceId } }
        ).subscribe((res: any) => {
              this.sOrigem = res;
            }, error => {
              this.loadingMaskService.setShowLoading(false);
              this.alertService.error('Generic.GlobalError');
              return false;
            });

        // No fim da leitura dos dados notificamos os subscritores do fim do carregamento através do Subject initialized
        this.loadWorkflowInstance()
          .subscribe(() => {
            if (this.workflowInstance.formData['Version']?.toString() === '2') {
              this.loadWorkflowDropdowns().subscribe(result => {
                this.workflowDropdowns = result;
                this._initialized.next();
                this.hideLoadingMask();
                this.workflowInstanceLoaded = true;
                this.hideLoadingMask();
                this.stepDetailsService.newWorkFlowCode(this.workflowInstance.workflowCode);

                if (this.workflowInstance.workflowCode == "PEDI0020B") {
                  const habilitaApagarCto: models.HabilitaApagarCtoVM = {
                    workflowInstanceId: this.workflowInstanceId,
                    workflowCode: this.workflowInstance.workflowCode
                  };
                  this.http.post<models.WorkflowStatusVM>("api/Workflow/HabilitaApagarCto", habilitaApagarCto)
                    .subscribe((result: models.WorkflowStatusVM) => {
                      if (result.stateCode == "OK") {
                        this.canApagarCTO = result.allowDelete;
                      } else {
                        this.alertService.error(result.message)
                      }
                    }, () => this.hideLoadingMask());
                } else {
                  this.canApagarCTO = true ;
                }
              }, () => { if (this.workflowVersion.toString() !== '2') this.hideLoadingMask() });
            } else {
              this.hideLoadingMask();
              this.workflowInstanceLoaded = true;
              this._initialized.next();
            }
            
          }, () => this.hideLoadingMask())
        }
      });

    this.mainSubscription.add( this.stepDetailsService.needsRevisionSubject.subscribe(result => this.showReturnButton = result));
    //const messageProp = this.translate.instant('Generic.DatePickerPlaceholder');
    
    const messageProp = this.translate.instant('Generic.DatePickerPlaceholder');
    ptBrLocale.invalidDate = messageProp;
    defineLocale('custom locale', ptBrLocale);
    this.localeService.use('custom locale');

    this.loadSystemInfo();
  }

  ngOnDestroy(): void {
    this.mainSubscription.unsubscribe();
    this.stepDetailsService.emitNeedsRevisionChange(false);
    this.stepDetailsService.newCurrentStep(undefined);
    this.stepDetailsService.workFlowCode.next(null);

  }

  public loadSystemInfo() {
    this.systemInformationService.loadCurrentSystemInformation().subscribe(result => {
      this.domain = this.securityService.userDetails.refererDomain + result.fileTransfer;
      this.isNSI = result.proveniencia == "NSI";
      //this.domain = result.cgaDirecta + result.fileTransfer;
    });
  }

  // Para ser chamado pelo filho quando tiver terminado a inicialização dos cartões
  activateStep(currentStep: StepComponent) {
    if (currentStep.currentStepCode != this.steps[this.steps.length - 1].stepCode && this.isReturn) {
      this.isReturn = false;
    }
    this.currentStep = currentStep;
    if (this.currentStep !== undefined) {
      this.currentStepIndex = this.steps.findIndex(step => step.stepCode === currentStep.currentStepCode);
      this.stepDetailsService.newCurrentStep(currentStep.currentStepCode);
    }
    //this.isDisabled = (!this.isLastStep) ? false : true;
    this.isDisabled = (!this.steps);
    
  }

  //COMPONENT RELATED METHODS
  /**
  * Got to next step, save data from current step
  *
  * @remarks
  * This is the workflow module interface.
  *
  */
  public async onStepNext() {
    this.isDisabled = true;
    this.loadingMaskService.setShowLoading(true, false);
    this.alertService.clear();

    if (this.isWorkflowSubmited || !this.canUserSaveData) {
      this.navigateToStep(false);
      this.hideLoadingMask();
      this.isDisabled = (!this.isLastStep) ? false : true;
      return;
    }
    else {
      //Preciso setar o touched no Next para forçar o display de errors e validações
      //Uma vez que não desejavam que estas estivessem visiveis ao carregar a aplicãçao
      Object.keys(this.cgaWorkflowForm.controls).forEach(controlKey => {
        this.cgaWorkflowForm.controls[controlKey].markAsTouched();
      })

      if (this.cgaWorkflowForm.invalid  ) {
        this.isDisabled = (!this.isLastStep) ? false : true;
        this.showErrorModalAndScroll();
        this.hideLoadingMask();
        this.isDisabled = (!this.isLastStep) ? false : true;
        return;
      }

      this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' | WorkComponent | onStepNext -> RefreshWorkFlowDataFromUI', LogType.Debug);
      this.RefreshWorkFlowDataFromUI();
      this.loadingMaskService.setShowLoading(true, false);
      var stepInvalid = false;
      

      //Validar se existem step anteriores não validados
      for (var index = 0; index < this.currentStepIndex; index++) {
        if (this.steps[index].stateCode == "PV" || this.steps[index].stateCode == "E") {
          stepInvalid = true;
          break;
        }
      }

      if (stepInvalid ) {
        this.alertService.error("Existem passos anteriores que não se encontram validados. Por favor complete e valide a informação.");
        window.scrollTo(0, 0);
        this.hideLoadingMask();
        this.isDisabled = (!this.isLastStep) ? false : true;
        return;
      }

      this.lastCurrentStep = this.activeRoute.firstChild.snapshot.params['currentStepCode'];
      var lastCurrentStepIndex = this.steps.findIndex(i => { return i.stepCode == this.lastCurrentStep });
      this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' | WorkComponent | onStepNext -> validateStepData', LogType.Debug);
      if (this.lastCurrentStep == "StepDocuments") {
        let allDocs = [];
        
        for (let i = 0; i < this.currentStep.cards.length; i++)
        {
          if (this.currentStep.cards[i].cardCode == "ServDocumentation") {
            allDocs = allDocs.concat(this.currentStep.stepData["ServDocumentation"]?.documentsList);
          }
          if (this.currentStep.cards[i].cardCode == "DocumentationMandatory") {
            allDocs = allDocs.concat(this.currentStep.stepData["DocumentationMandatory"]?.documentsList);
          }
        }

        const result = this.isDocumentationOk(allDocs);
        if (!result) {
          this.isDisabled = (!this.isLastStep) ? false : true;
          return;
        }
      }
      (await this.validateStepData()).pipe(
        filter(() => this.currentStepDefinition.stateCode === "V"),
        switchMap(() => this.http.post<void>('api/Workflow/SaveWorkflowInstance', this.workflowInstance.formData, { params: { workflowInstanceId: this.workflowInstanceId } })),
      ).subscribe(
        () => {
          this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' | WorkComponent | onStepNext -> validateStepData Subscribe navigateToStep - Start', LogType.Debug);
          this.navigateToStep(false);
          this.alertService.success("Workflow.NextSaveSucess");
          this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' | WorkComponent | onStepNext -> validateStepData Subscribe navigateToStep - End', LogType.Debug);
          //this.isDisabled = (!this.isLastStep) ? false : true;
        },
        error => {
          console.log(error);
          //this.isDisabled = (!this.isLastStep) ? false : true;
          //this.hideLoadingMask();
        },
        () => {
          this.hideLoadingMask();
          this.isDisabled = (!this.isLastStep) ? false : true;
        },
        );
    }

    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' | WorkComponent | onStepNext -> exit', LogType.Debug);
  }

  private detectScrollbarVerticalNeed() {
    const body = document.body;
    const needForScroll = body.getBoundingClientRect().top<0;
    if (needForScroll) {
      body.classList.add("scroll-need");
    } else {
      body.classList.remove("scroll-need");
    }

  }
  private showErrorModalAndScroll() {
    this.detectScrollbarVerticalNeed();
    window.scrollTo(0, 0);
    (<any>document.activeElement).blur();
    this.modalRef = this.bsModalService.show(
      this.errorsFound,
      Object.assign({}, { class: 'modal-lg' }));
   
    this.isDisabled = (!this.isLastStep) ? false : true;
    this.mainSubscription.add(
      this.modalRef.onHide.subscribe(res =>
        this.detectScrollbarVerticalNeed()
      )
    );
    
  }

  private navigateToStep(goBack: boolean) {
    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' | WorkComponent | navigateToStep - Start', LogType.Debug);
    const indexIncrement = goBack ? -1 : 1;
    const nextCode = this.steps[this.currentStepIndex + indexIncrement].stepCode;

    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' | WorkComponent | navigateToStep - nextCode -> ' + nextCode , LogType.Debug);

    if (goBack && !this.isAtendimento) {
      this.menuSideBarClick(nextCode).then(res => {
        if (res === true) {
          this.router.navigate(['step', nextCode], {
            relativeTo: this.activeRoute
          });
          window.scrollTo(0, 0);
        }
      });
    }
    else {
      this.router.navigate(['step', nextCode], {
        relativeTo: this.activeRoute
      });
      window.scrollTo(0, 0);
    }
    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' | WorkComponent | navigateToStep - End', LogType.Debug);
  }
  /**
  * Got to precious step, save data from current step
  *
  * @remarks
  * This is the workflow module interface.
  *
  */
  public onStepBefore() {
    if (this.currentStepCode == "StepDocuments") {
      //Corrige uma NC que está acontecer nas CT´s obrigatórias ou voluntárias
      if (this.workflowInstance.formData.StepDocuments === null || this.workflowInstance.formData.StepDocuments === undefined) {
        this.workflowInstance.formData.StepDocuments = {} as any;
      }
      //Check if object ServDocumentation exist, if it doesn't the recreate it
      if ((this.workflowInstance.formData.StepDocuments as any).ServDocumentation == null ||
        (this.workflowInstance.formData.StepDocuments as any).ServDocumentation == undefined) {
        (this.workflowInstance.formData.StepDocuments as any).ServDocumentation = {
          documentsList:[]
        }
      }
      //Check if object DocumentationMandatory exist, if it doesn't the recreate it
      if ((this.workflowInstance.formData.StepDocuments as any).DocumentationMandatory == null ||
        (this.workflowInstance.formData.StepDocuments as any).DocumentationMandatory == undefined) {
        (this.workflowInstance.formData.StepDocuments as any).DocumentationMandatory = {
          documentsList: []
        }
      }

      const arrayDocs: DocumentVMExtension[] = (this.workflowInstance.formData.StepDocuments as any).ServDocumentation?.documentsList;
      const arrayMandatoryDocs: DocumentVMExtension[] = (this.workflowInstance.formData.StepDocuments as any).DocumentationMandatory?.documentsList;
      let allDocs = [];
      if (arrayDocs !== null && arrayDocs !== undefined) {
        allDocs = allDocs.concat(arrayDocs);
      }
      if (arrayMandatoryDocs !== null && arrayMandatoryDocs !== undefined) {
        allDocs = allDocs.concat(arrayMandatoryDocs);
      }

        const result = this.isDocumentationOk(allDocs,false);
        if (!result) {
          var confirmDeleteModal = <models.BaseModalVM>{ isError: false, message: "Workflow.DocumentsToBeSubmitted" };
          return this.modalService.showModals([confirmDeleteModal]).subscribe(resultSubscribe => {
            if (!resultSubscribe) {
              return;
            }
            else {
              this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId! + ' | WorkComponent | onStepBefore -> RefreshWorkFlowDataFromUI', LogType.Debug);
              this.RefreshWorkFlowDataFromUI();

              if (this.isReturn) {
                this.router.navigate(['workflow/', this.workflowInstanceId, 'step', this.lastCurrentStep]);
                this.isReturn = false;
              } else {
                this.navigateToStep(true);
              }
            }
          });
        }
      }
      this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId! + ' | WorkComponent | onStepBefore -> RefreshWorkFlowDataFromUI', LogType.Debug);
      this.RefreshWorkFlowDataFromUI();

      if (this.isReturn) {
        this.router.navigate(['workflow/', this.workflowInstanceId, 'step', this.lastCurrentStep]);
        this.isReturn = false;
      } else {
        this.navigateToStep(true);
      }
    }

  //INTERNAL API CALLS
  /**
  * Search for a workflow instance for a given subscriber
  *
  * @remarks
  * This is an api call 
  *
  */
  public loadWorkflowInstance() {

    return this.http.get<models.WorkflowInstanceVM>('api/Workflow/LoadWorkflowInstance', { params: { workflowInstanceId: this.workflowInstanceId } }
    ).pipe(
      mergeMap((wfi: models.WorkflowInstanceVM) => {

      this.workflowInstance = wfi;
      this.workflowInstance.formData = this.workflowInstance.formData || {};
        this.workflowVersion = this.workflowInstance.formData['Version']
        // Verifica se é do tipo de pedido Prestações por morte
        if (this.workflowInstance.workflowCode == 'PEDI002' ||
          this.workflowInstance.workflowCode == 'PEDI002A' ||
          this.workflowInstance.workflowCode == 'PEDI002B') {
          this.router.navigate([`workflow/${this.workflowInstanceId}/${this.workflowInstance.workflowCode}/step/StepSender`]);
          return;
        }
        if (this.workflowInstance.stateCode == "E") {
          this.alertService.error(this.workflowInstance.message);
          this.iCanAccess = false; //Desativar os botões
          
          this.hideLoadingMask();
        }
        else {
          if (this.workflowInstance) {

            const workflowsInformations$: Observable<models.WorkflowInformationVM> =
              this.http.get<models.WorkflowInformationVM>('api/Workflow/LoadWorflowInformation', { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowInstance.workflowCode } });

            const workflowsHelpLinks$: Observable<models.WorkflowHelpLinkVM[]> =
              this.http.get<models.WorkflowHelpLinkVM[]>('api/Workflow/LoadWorkflowsHelpLinks', {});

            return combineLatest(workflowsInformations$, workflowsHelpLinks$)
              .pipe(
                filter(([workflowsInformations, workflowsHelpLinks]) => workflowsInformations !== null && workflowsHelpLinks !== null),
                map(([workflowsInformation, workflowsHelpLinks]) => {
                  if (!this.isNumeric(workflowsInformation.workFlowHelpLink) && workflowsInformation.workFlowHelpLink.length > 0) {
                    const foundEntry = workflowsHelpLinks.find(wh => wh.codigo == workflowsInformation.workFlowHelpLink);
                    if (foundEntry !== null && foundEntry !== undefined) {
                      workflowsInformation.workFlowHelpLink = foundEntry.refFichId.toString();
                    } else {
                      const logModel: models.LogModelVM = {
                        message: `Could not found refFichId for workFlowHelpLink: ${workflowsInformation.workFlowHelpLink}`,
                        type: LogType.Error
                      };
                      this.logService.logToBackend(logModel);
                      this.cacheService.cacheMissingHelpLink(workflowsInformation.workflowCode);
                    }

                  }

                  return workflowsInformation;
                }),
                mergeMap((wfinfo, index) => {
                  this.workflowTemplate = { ...wfinfo } as models.WorkflowTemplateVM;
                  const isExSubscritor = (this.workflowInstance.workflowCode.indexOf('PEDI008') == -1 &&
                    this.workflowInstance.workflowCode.indexOf('PEDI005') == -1) ? false : true;
                  return this.http.get<models.WorkflowTemplateVM>('api/Workflow/LoadWorkflowTemplate', { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowInstance.workflowCode } })
                    .pipe(map(wft => {

                      //console.log(`Loaded workflow template for workflow: ${wft}`);

                      //this.workflowTemplate.steps = wft.steps;
                      //this.steps = wft.steps;


                      let filteredSteps = [];
                      for (let i = 0; i < wft.steps.length; i++) {
                        if (wft.steps[i].stepCode !== 'StepCertification') {
                          filteredSteps.push(wft.steps[i]);
                        }
                      }

                      // TODO: Vou mudar os titulos dos cards mas isto é responsabilidade do PlSql
                      if (isExSubscritor) {
                        filteredSteps.forEach(stp => {
                          stp.cards.forEach(crd => {
                            switch (crd.cardCode) {
                              case "RemunerationsCurrentMonthly":
                                crd.title = "Remuneração à data de cessação de funções";
                                break;
                              case "RemunerationsTriennium":
                                crd.title = "Remunerações auferidas no triénio 2003/2005";
                                break;
                              case "RemunerationsLastThreeYears":
                                crd.title = "Remunerações auferidas nos últimos três anos anteriores à data de cessação de funções";
                                break;
                              case "RemunerationsLastUntilCutoff":
                                crd.title = "Última remuneração mensal auferida até dezembro 2005";
                                break;
                            }
                          });
                        });
                      }

                      this.workflowTemplate.steps = filteredSteps;
                      this.steps = filteredSteps;

                      Object.keys(this.cgaWorkflowForm.controls).forEach(controlKey => {
                        this.cgaWorkflowForm.controls[controlKey].disable();
                      })

                      // Não vamos validar se a rota bate certo com a definição de steps do workflow
                      // Isso é um erro e como tal deve estoirar
                      // Mesmo que validássemos nunca saberíamos resolver a situação, lançar alerta ao utilizador e depois?
                      // A fazer alguma validação será sempre no filho

                      return wft;
                    }));
                })
              );

            //console.log(`Loaded workFlow Instance Id: ${this.workflowInstanceId}`, this.workflowInstance)


          }
        }
    }));
    
  }

  private isNumeric(str: string): boolean {
    if (typeof str != "string") return false; // we only process strings!
    if (str === null || str === undefined) return false; // null or undefineds are not numbers
    if (str.length === 0) return false; // empty string are not numbers
    return !isNaN(str as any) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
  }

  public loadWorkflowDropdowns() {
    return this.http.get<models.WorkflowDropdownsVM>('api/Workflow/LoadWorkflowDropdowns', { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowInstance.workflowCode } })

  }

  /**
* Persist card information for the workflow.
*
* @remarks
* This is the workflow module interface.
*
*/
  public onSaveWorkflowData(event: Event) {
    // Como este é o primeiro botão do Form o angular decide que é um submit
    // assim temos que evitar o comportamento default, senão faz refresh à pagina
    event.preventDefault();

    //REFRESH DATA FROM STEPS
    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' | WorkComponent | onSaveWorkflowData -> RefreshWorkFlowDataFromUI', LogType.Debug);
    this.RefreshWorkFlowDataFromUI();
    this.loadingMaskService.setShowLoading(true, false);

    this.http.post<models.WorkflowStatusVM>('api/Workflow/SaveWorkflowInstance', this.workflowInstance.formData, { params: { workflowInstanceId: this.workflowInstanceId } })
      .subscribe((wf: models.WorkflowStatusVM) => {
        this.alertService.clear();
        if (wf.stateCode == <string>"OK") {
          if (this.workflowInstance.workflowCode.indexOf("PEDI0020") > -1) {
            this.alertService.success("Workflow.SaveSucessCT")
          } else {
            this.alertService.success("Workflow.SaveSucess")
          }
        }
        else {
          this.alertService.error(wf.message)
        }
        this.hideLoadingMask()
      },
        error => this.hideLoadingMask()
      );

  }

  /**
 * Delete instance of workflow
 *
 * @remarks
 * This is the workflow module interface.
 *
 */
  public onDeleteWorkflowData(event: Event) {
        event.preventDefault();
        //DELETE DATA
        let confirmMessage = "Workflow.ConfirmDeleteWorkflowData.";
        const isSubscritor = this.workflowInstance.workflowCode.indexOf("PEDI005") > -1 ||
          this.workflowInstance.workflowCode.indexOf("PEDI008") > -1;
        const isPedi20 = this.workflowInstance.workflowCode.indexOf("PEDI0020") > -1;
        confirmMessage += this.workflowTemplate.mandatory ? "Mandatory" :
          isPedi20 ? "NotMandatoryPEDI0020" :
            isSubscritor ? "NotMandatoryPEDI005" :
              "NotMandatory";


        var confirmDeleteModal = <models.BaseModalVM>{ isError: false, message: confirmMessage };
        this.modalService.showModals([confirmDeleteModal]).subscribe(result => {
          if (!result)
            return;

          //console.log(`Delete workflow intance: ${this.workflowInstanceId}`)
          this.loadingMaskService.setShowLoading(true, false);
          this.http.post<models.WorkflowStatusVM>('api/Workflow/DeleteWorkflowInstance', null, { params: { workflowInstanceId: this.workflowInstanceId } }
          ).subscribe((result: models.WorkflowStatusVM) => {
            if (result.stateCode == 'OK') {
              this.http.get<models.WorkflowInstanceVM>('api/Workflow/LoadWorkflowInstance', { params: { workflowInstanceId: this.workflowInstanceId } }
              ).subscribe((wfi: models.WorkflowInstanceVM) => {
                this.hideLoadingMask();
                this.workflowInstance = wfi;
                this.workflowInstance.formData = this.workflowInstance.formData || {};
                if (this.currentStepIndex === 0)
                  this.currentStep.renavigateToRoot();
                else
                  this.navigateToRootStep();

                for (let i = 0; i < this.steps.length; i++) {
                  this.steps[i].stateCode = 'PV';
                }
                this.alertService.clear();
                const message = this.workflowInstance.workflowCode.indexOf("PEDI0020") > -1 ?
                  "Workflow.DeleteSucessCT" :
                  "Workflow.DeleteSucess"
                this.alertService.success(message);
              }, error => {
                console.error(error);
                this.hideLoadingMask();
              });
            }
            else {
              this.hideLoadingMask();
              this.alertService.clear();
              this.alertService.error(result.message);
            }
          }, error => {
            //this.alertService.error("Workflow.DeleteError");
            console.error(error);
            this.hideLoadingMask();
          })
        });    
  }


   /**
  * Submit current workflow data to CGA systems.
  *
  * @remarks
  * Submits the current workflow data to CGA systems.
  *
  */
  public onSubmit(event: Event, btn: HTMLButtonElement) {
    //Validar se existem step anteriores não validados
    var stepInvalid = false;

    for (var index = 0; index < this.currentStepIndex; index++) {
      if (this.steps[index].stateCode == "PV" || this.steps[index].stateCode == "E") {
        stepInvalid = true;
        break;
      }
    }

    if (stepInvalid && !this.isReturn) {
      this.alertService.error("Existem passos anteriores que não se encontram validados. Por favor complete e valide a informação.");
      window.scrollTo(0, 0);
      this.hideLoadingMask();
      this.isDisabled = (!this.isLastStep) ? false : true;
      return;
    }

    //REFRESH DATA FROM STEPS
    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' | WorkComponent | onSubmit -> RefreshWorkFlowDataFromUI', LogType.Debug);
    this.RefreshWorkFlowDataFromUI();

    Object.keys(this.cgaWorkflowForm.controls).forEach(controlKey => {
      this.cgaWorkflowForm.controls[controlKey].markAsTouched();
    })

    if (this.cgaWorkflowForm.invalid)
      return;

    btn.disabled = true;
    var syncDocsvalidated = false;
    this.loadingMaskService.setShowLoading(true, false);

    const needsRevision = this.currentStep.getWorkflowNeedsRevision();

    if (!needsRevision.revisionNeeded) {
      //VALIDATE CURRENT STEP
      this.validateWorkflowData().pipe(
        filter(() => !this.steps.some(x => x.stateCode !== StepStateCodes.valid && x.stateCode !== StepStateCodes.dOverlap ) || this.isReturn),
        // Save workflow data
        switchMap(() => this.http.post<void>('api/Workflow/SaveWorkflowInstance', this.workflowInstance.formData, { params: { workflowInstanceId: this.workflowInstanceId } })),
        filter((result) => {
          const res: models.WorkflowStatusVM = (<any>result) as models.WorkflowStatusVM;
          if (res.stateCode == "E") {
            this.alertService.error(res.message);
            btn.disabled = true;
            return false;
          }
          return true;
        }),
        tap((result) => {
          
          this.isReturn = false
        }
        ),
        // Synch documents if needed
        switchMap(() => {
          if (this.workflowTemplate.mandatory || (!this.workflowTemplate.mandatory && this.isWorkflowOnSubscriber && !needsRevision.revisionNeeded)) {

            return this.http.get("api/Workflow/GetIfedorchav", { params: { workflowInstanceId: this.workflowInstanceId }, responseType: 'text' })
              .pipe(
                switchMap(result => this.http.post<void>('api/Documents/SyncDocuments', result, { params: { workflowInstanceId: this.workflowInstanceId, subscriberNumber: this.workflowInstance.subscriberNumber, isPrestage: false } })
                ));
          }
          else
            return of(null);
        }),
        // Submit workflow
        switchMap(() => {
          syncDocsvalidated = true;
          return this.http.post<void>('api/Workflow/SendWorkflow', needsRevision, { params: { workflowInstanceId: this.workflowInstanceId, revisionNeeded: needsRevision.revisionNeeded } })
        }),
        //redirecionar para a home e mostrar mensagem.
        tap(() => {
          const navigationExtras: NavigationExtras = { state: { data: this.getSubmitSuccessMessage(needsRevision.revisionNeeded), code: 'OK' } };
          // The next line is telling header component to hide the help button;
          this.stepDetailsService.workFlowCode.next(null);
          this.router.navigate(['submited'], navigationExtras);
        }),
        catchError((error) => {
          if (syncDocsvalidated)
            return this.http.post<void>('api/Documents/EndDocuments', undefined, { params: { workflowInstanceId: this.workflowInstanceId, subscriberNumber: this.workflowInstance.subscriberNumber } });;

          if (error == undefined)
            this.alertService.error("Não foi possível submeter o seu pedido. Por favor, tente mais tarde.");

          return of(null);
        })
      ).subscribe(
        () => {
          // The next line is telling header component to hide the help button;
          this.stepDetailsService.workFlowCode.next(null);
          btn.disabled = false;
        },
        (error) => { btn.disabled = false;},
        () => {
          this.hideLoadingMask();
       
     

        }
      );
    } else {
      // Save workflow data
      this.http.post<models.WorkflowStatusVM>('api/Workflow/SaveWorkflowInstance', this.workflowInstance.formData, { params: { workflowInstanceId: this.workflowInstanceId } }).pipe(
        tap((result: models.WorkflowStatusVM) => {
          if (result.stateCode == 'OK') {
            this.isReturn = false;
          }
          else {
            this.hideLoadingMask();
            this.alertService.clear();
            this.alertService.error(result.message);
          }
          return result;
        }),
        filter((result: models.WorkflowStatusVM) => {
          return result.stateCode == 'OK';
        }),
        // Submit workflow
        switchMap(() => this.http.post<void>('api/Workflow/SendWorkflow', needsRevision, { params: { workflowInstanceId: this.workflowInstanceId, revisionNeeded: needsRevision.revisionNeeded.toString() } })),
        //redirecionar para a home e mostrar mensagem.
        tap(() => {
          // The next line is telling header component to hide the help button;
          this.stepDetailsService.workFlowCode.next(null);

          const navigationExtras: NavigationExtras = { state: { data: this.getSubmitSuccessMessage(needsRevision.revisionNeeded), code: 'OK' } };
          this.router.navigate(['submited'], navigationExtras);
        })
      ).subscribe(
        () => {
          this.hideLoadingMask(); btn.disabled = false;
        },
        (error) => {
          this.hideLoadingMask(); btn.disabled = false;
        }
      );
    }
  }

  private getSubmitSuccessMessage(revisionNeeded: boolean) {
    //Condição é responsável pelo envio da mensagem na submissão dos pedidos, Obrigatórios e Voluntários
    if (this.workflowTemplate.mandatory || ((this.workflowInstance.statePhase == 'SPS' || this.workflowInstance.statePhase == 'NPS') && !revisionNeeded))
      return this.translate.instant((this.workflowInstance.workflowCode.indexOf("PEDI0020") > -1 || this.workflowInstance.workflowCode.indexOf("PEDI008") > -1)
        ? 'Workflow.SendToCGAMessageCT'
        : 'Workflow.SendToCGAMessage');
    //Condição responsável por enviar a mensagem quando o Pedido é devolvido ao Serviço quando ocorre uma situação de Devolução por parte do Subscritor
    else if (this.workflowInstance.statePhase == 'NPS' && revisionNeeded)
      return this.translate.instant('Workflow.SendToServiceMessage');
    // Condição responsável por enviar a mensagem quando o Pedido é enviado para o Susbcritor pelo Serviço, quer tenha existido antes uma Devolução ou não
    else if (!this.workflowTemplate.mandatory && (this.workflowInstance.statePhase == 'NPV' || this.workflowInstance.statePhase == 'NPA'))
      return this.translate.instant('Workflow.SendToSubscriberMessage');
    else
      return 'Devido a uma situação imprevista, não foi possível executar a ação pretendida.';
  }

  /**
  * Validate given Step
  *
  * @remarks
  * This is an api call
  *
  */
  private async validateStepData() {

    //this.currentStep.currentStepCode

    //return await this.http.post<models.WorkflowStepValidationsVM>(`api/Workflow/ValidateStepData`, this.getStepData(this.currentStepCode),
    //  { params: { workflowInstanceId: this.workflowInstanceId, stepCode: this.currentStepCode, isSubscriber: this.isWorkflowOnSubscriber.toString() } }
    return await this.http.post<models.WorkflowStepValidationsVM>(`api/Workflow/ValidateStepData`, this.currentStep.stepData,
      { params: { workflowInstanceId: this.workflowInstanceId, stepCode: this.currentStep.currentStepCode, isSubscriber: this.isWorkflowOnSubscriber.toString() } }
    ).pipe(
      switchMap((wv: models.WorkflowStepValidationsVM) => {
        this.currentStepDefinition.stateCode = wv.stateCode;
        if (wv.stateCode !== StepStateCodes.valid) {
          if (wv.stateCode === "XE") {
            var errorMessage = "";
          }
          if (wv.stateCode !== "MI" && wv.stateCode !== "XE" && wv.stateCode !== "TE") {
            this.showErrorModalAndScroll();
          }
          if (wv.stateCode === "MI" || wv.stateCode === "ME") {
            var errorMessage = "";
            if (!isNullOrUndefined(wv.errors) && wv.errors.length > 0)
              errorMessage = wv.errors[0].message;
            else
              errorMessage = wv.message;

            var errorInfoModal = <models.BaseModalVM>{ isError: wv.stateCode === "ME", message: errorMessage };

            return this.modalService.showModals([errorInfoModal]).pipe(
              map(result => {
                //OK no modal informativo result=true, consideramos o Step Validado
                //Cancelar no modal informativo result=false, consideramos o Step Não Validado
                result ? this.currentStepDefinition.stateCode = "V" : this.currentStepDefinition.stateCode = "E";
                if ( wv.stateCode === "MI") {
                  this.isDisabled = false;
                }
              })
            );
          }
          else if (wv.errors) {
            wv.errors.forEach(e => this.alertService.error(e.message));
          }
          this.isDisabled = (!this.isLastStep) ? false : true;
        }
        else {
          if (wv.errors) {
            this.externalValidationsService.setStepExternalErrors(wv);
            this.isDisabled = (!this.isLastStep) ? false : true;
          }
          //this.setStepData(this.currentStepCode, wv.stepData[this.currentStepCode]);
        }

        return of(null);
      })
    );
  }

  /**
  * Validate given Step
  *
  * @remarks
  * This is an api call
  *
  */
  private validateWorkflowData() {
    this.alertService.clear();
    return this.http.post<models.WorkflowValidationsVM>(`api/Workflow/ValidateWorkflowData`, this.workflowInstance.formData,
      { params: { workflowInstanceId: this.workflowInstanceId } }
    ).pipe(map((wv: models.WorkflowValidationsVM) => {
      if (isNullOrUndefined(wv.stepValidationsResult))
        wv.stepValidationsResult = [] as models.WorkflowStepValidationsVM[]

      this.workFlowErrors = wv;

      this.externalValidationsService.setExternalErrors(wv);
      //Sets error state in steps that were returned as invalid
      this.markInvalidSteps(wv);

      const currentStepValidation = wv.stepValidationsResult?.find(v => v.stepCode === this.currentStepCode);
      if (currentStepValidation) {
        this.currentStepDefinition.stateCode = currentStepValidation.stateCode;
        if (currentStepValidation.stateCode === StepStateCodes.valid) {
          if (currentStepValidation.errors) {
            currentStepValidation.errors.forEach(e => this.alertService.info(e.message));
          }
        }
        else {
          if (currentStepValidation.errors) {
            currentStepValidation.errors.forEach(e => this.alertService.error(e.message));
          }
        }
      }
      else {
        this.currentStepDefinition.stateCode = StepStateCodes.valid
      }

      if (wv.stepValidationsResult.some(val => val.stateCode !== StepStateCodes.valid && val.stateCode !== "XE")) {
        this.alertService.error("Workflow.ErrorsOnPreviousSteps");
        wv.stepValidationsResult[0].errors.forEach(e => this.alertService.error(e.message));
      }

    }));

  }

  private markInvalidSteps(wv: models.WorkflowValidationsVM) {
    wv?.stepValidationsResult?.forEach(stepValidation => {
      if (stepValidation.stateCode !== StepStateCodes.valid) {
        var stepWithError = this.getStepDefinition(stepValidation.stepCode);
        stepWithError.stateCode = stepValidation.stateCode;
      }
    })
  }

  //GETTER/SETTERS
  public getStepDefinition(stepCode: string): models.StepVM {
    return this.steps.find(s => s.stepCode === stepCode);
  }

  public getStepData(stepCode: string) {
    return this.workflowInstance.formData[this.getStepDefinition(stepCode).stepDataPropertyName];
  }
  /*
  public setStepData(stepCode: string, value: {}) {
    //console.log(`JSON Data for step ${stepCode}:`, value);
    
    var sCards = "";

    var deleteKeys = new Array();
    for (const key in value) {
      if (this.workflowTemplate.steps.find(step => step.stepCode === stepCode).cards.find(c => c.cardCode === key) == undefined) {
        deleteKeys.push(key);
      }
      sCards += key + ";";
    }

    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' | WorkComponent | setStepData | StepCode ' + stepCode + ' | cards: ' + sCards, LogType.Debug);
    
    if (deleteKeys.length > 0) {
      for (var i = 0; i < deleteKeys.length; i++) {
        delete (value)[deleteKeys[i]];
      }
    }

    var cardCount = 0;
    for (const key in value) {
      cardCount++;
    }

    if (cardCount > 0) {
      this.workflowInstance.formData[stepCode] = value as any;
    }
    else {
      if (this.workflowInstance.formData[stepCode] == undefined) { //Se step novo a ser criado temos que adicionar mesmo sem cartões.
        this.workflowInstance.formData[stepCode] = value as any;
      }
    }
  }
  */

  public setStepData() {
    //console.log(`JSON Data for step ${stepCode}:`, value);
    var sCards = "";
    var deleteKeys = new Array();
    var aCards = new Array();
    var oStepData;

    for (var i = 0; i < this.currentStep.cards.length; i++) {
      if (this.workflowTemplate.steps.find(step => step.stepCode === this.currentStep.currentStepCode).cards.find(c => c.cardCode === this.currentStep.cards[i]["cardCode"]) == undefined) {
        deleteKeys.push([this.currentStep.cards[i]["cardCode"]]);
      }
      else {
        aCards.push(this.currentStep.cards[i]);
      }
      sCards += this.currentStep.cards[i]["cardCode"] + ";";
    }

    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' | WorkComponent | setStepData | StepCode ' + this.currentStep.currentStepCode + ' | cards: ' + sCards, LogType.Debug);

    if (deleteKeys.length > 0) {
      this.currentStep.cards = null;
      this.currentStep.cards = aCards;

      oStepData = this.currentStep.stepData;

      for (var i = 0; i < deleteKeys.length; i++) {
        delete (oStepData)[deleteKeys[i]];
      }

      if (oStepData.length > 0) {
        this.workflowInstance.formData[this.currentStep.currentStepCode] = oStepData;
      }
    }
    else {
      this.workflowInstance.formData[this.currentStep.currentStepCode] = this.currentStep.stepData as any;
    }
  }

  public get currentStepCode(): string {
    return this.currentStep.currentStepCode;
  };

  protected RefreshWorkFlowDataFromUI() {
    var sCards = Object.keys(this.currentStep.stepData).join(";");
    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' | WorkComponent | RefreshWorkFlowDataFromUI | StepCode ' + this.currentStepCode + ' | Cards: ' + sCards, LogType.Debug);

    this.setStepData();
  }

  public getWorkflowState(): string {
    return this.workflowInstance.statePhase;
  }

  public navigateToRootStep() {
    const nextCode = this.steps[0].stepCode;
    return this.router.navigate(['step', nextCode], {
      relativeTo: this.activeRoute
    });
  }

  public getInstructions() {
    if (!this.cacheService.isMissingHelpLink(this.workflowTemplate.workflowCode)) { 
      console.log("Workflow Help Link: ", this.workflowTemplate.workFlowHelpLink);
      this.cgaGetFileForm.nativeElement.action = this.domain;
      this.cgaGetFileForm.nativeElement.submit();
      return false;
    } else {
      const message = this.translate.instant("BaseModal.HelpLinkNotFound");
      this.alertService.error(message);
      return false;
    }
  
  }
  public hideLoadingMask() {
    this.loadingMaskService.setShowLoading(false);
  }

  public onDeleteWorkflow(event: Event) {
        // Validar se é serviço, se é pedido de Ex-subscritor, se passou pela SGA ou tem origem MGPA
        if (
          ((this.workflowInstance.workflowCode.indexOf('PEDI008') != -1 || this.workflowInstance.workflowCode.indexOf('PEDI005') != -1)
            && this.securityService.userDetails.informationGroups.includes("PGPS")
            //&& (this.workflowInstance.formData.stepPreStage['preStageInfo']['isSentCGA'] == "true" || this.sOrigem == 1)
          )
          || (this.workflowInstance.workflowCode.indexOf('PEDI0020B') != -1 && this.securityService.userDetails.informationGroups.includes("PGPS") && this.sOrigem == 1) //CTO Normal criada via MGPA
        ) {

          this.router.navigate([`workflow-create/${this.workflowInstance.workflowCode}/${this.workflowInstanceId.toString()}/${this.workflowInstance.subscriberNumber}/96`]);
          return;
        }

        event.preventDefault();
        //DELETE WORKFLOW
        var confirmMessage = "Workflow.ConfirmDeleteWorkflowGeneric";
        var confirmDeleteModal = <models.BaseModalVM>{ isError: false, message: confirmMessage };
        this.modalService.showModals([confirmDeleteModal]).subscribe(result => {
          if (!result) return;

          this.loadingMaskService.setShowLoading(true, false);
          this.http.post<models.WorkflowStatusVM>('api/Workflow/TerminateWorkflowInstance', null, { params: { workflowInstanceId: this.workflowInstanceId } }
          ).subscribe((result: models.WorkflowStatusVM) => {
            this.hideLoadingMask();
            if (result.stateCode == 'OK') {
              const messagemApagado = "WorkflowSearch.TerminatedWorkflowGeneric";
              const navigationExtras: NavigationExtras = { state: { data: messagemApagado, code: 'OK' } };

              // PIT 40803 \\
              const validOption = ['/instancebrowser', '/workflowSearch'];

              const dadosOrigem = this.sessionStorageService.getOrigemPedidoOptionOnCache();

              if (dadosOrigem != null && validOption.includes(dadosOrigem.origemDoAcesso)) {
                this.destinoRouter = dadosOrigem.origemDoAcesso;
              }
              else {
                this.destinoRouter = '/workflowSearch';
              }
              // PIT 40803 \\
              this.router.navigate([this.destinoRouter], navigationExtras);
            }
            else {
              this.alertService.clear();
              this.alertService.error(result.message);
            }
          },
            error => this.hideLoadingMask()
          )
        });
  }

  public onRedirect() {
    this.lastCurrentStep = this.activeRoute.firstChild.snapshot.params['currentStepCode'];
    this.isReturn = true;
    this.showReturnButton = true;
    this.navigateToEnd();
  }


  public navigateToEnd() {
    const lastStep = this.steps[this.steps.length - 1].stepCode;
    return this.router.navigate(['workflow/', this.workflowInstanceId, 'step', lastStep]);
  }

  public menuSideBarClick(currentStep: string, fromHTML: boolean = false, stateCode: string = ""): Promise <boolean>{

      if (currentStep != this.steps[this.steps.length - 1].stepCode && this.isReturn) {
        this.isReturn = false;
      }

      this.lastCurrentStep = this.activeRoute.firstChild.snapshot.params['currentStepCode'];
      this.nextMenuStep = currentStep;

      if (this.lastCurrentStep != currentStep && !this.isAtendimento && !this.isWorkflowSubmited) {
        return this.invalidateSteps(fromHTML).then(res => {
          if (fromHTML && res) {
            if (stateCode != "PV") {
              this.router.navigate(['step', currentStep], {
                relativeTo: this.activeRoute
              });
            }
          }

          return Promise.resolve(res);
        });
      }
      else {
        if (stateCode != "PV") {
          this.router.navigate(['step', currentStep], {
            relativeTo: this.activeRoute
          });
        }

        return Promise.resolve(true);
      }
  }


  public invalidateSteps(fromHTML: boolean = false): Promise<boolean> {

    var lastCurrentStepIndex = this.steps.findIndex(i => { return i.stepCode == this.lastCurrentStep });
    var nextStepIndex = this.steps.findIndex(i => { return i.stepCode == this.nextMenuStep });
    var currentStepCode = this.steps[this.currentStepIndex].stepCode;

    var stepsToInvalidate = "";
    var stepsCodeToRecover = "";

    //Obter o Último Step Validado
    for (var index = this.steps.length - 1; index >= 0; index--) {
      if (this.steps[index].stateCode == "V" || this.steps[index].stateCode == "E" || this.steps[index].stateCode == "MI") {
        lastCurrentStepIndex = index;
        break;
      }
      //if (this.steps[index].stateCode == "PV") {
      //  lastCurrentStepIndex = index - 1;claro
      //  break;
      //}
    }

    //if (this.steps[lastCurrentStepIndex].stateCode == "PV")
    //  lastCurrentStepIndex--;

    //Situação em que se acede ao step mudando o endereço na barra de URL em que ficam para trás steps que não estão em "Por Validar" ou em "Erro" então devemos colocar como ultimo step o step atual.
    if (nextStepIndex > lastCurrentStepIndex) {
      //stepsCodeToRecover = this.steps[lastCurrentStepIndex].stepCode;
      lastCurrentStepIndex = this.steps.findIndex(i => { return i.stepCode == this.lastCurrentStep });
    }

    //Criar string com todos os steps a invalidar
    for (var i = nextStepIndex; i <= lastCurrentStepIndex; i++) {
      stepsToInvalidate += this.steps[i].stepCode + ";";
    }

    if (stepsToInvalidate.length > 0) {
        //Chamar função InvalidaSteps no WorkflowController passando o ID da instância e os Steps a invalidar
        return this.http.post('api/Workflow/InvalidaSteps', null, { params: { workflowInstanceId: this.workflowInstanceId, steps: stepsToInvalidate } }
        ).toPromise().then((result) => {

          if (result != null && result["stateCode"] == "OK") {
            for (var i = nextStepIndex; i <= lastCurrentStepIndex; i++) {
              this.steps[i].stateCode = "E";
            }
            return Promise.resolve(true);
          }

          else {
            if (!fromHTML) {
              this.router.navigate(['step', currentStepCode], {
                relativeTo: this.activeRoute
              });
            }
            this.alertService.error(result["message"]);
            window.scrollTo(0, 0);

            return Promise.resolve(false);
          }

        });
      } 
    else {
      return Promise.resolve(true);
    }
  }

  public writeToLog(message: string, logType: LogType) {
    var logModel: models.LogModelVM = {
      message: message,
      type: logType
    };
    this.logService.logToBackend(logModel);
  }

  isDocumentationOk(newDocumentList: DocumentVMExtension[], showMessage: boolean = true): boolean {

    // Refresh intitial mandatory list
    const initialMandatory = newDocumentList.filter(el => el.isMandatoryFile?.toString()?.toLowerCase() === 'true')

    let isDocumentsOk: boolean = true;
    // testar os documentos obrigatórios primeiro à procura de inválidos 
    if (initialMandatory.length > 0) {
      initialMandatory.forEach((el: DocumentVMExtension) => {
        if (el.fileID == null || el.fileID == undefined || el.fileID == "0") {
          isDocumentsOk = false;
        }
      });
    }
    // testar os todos os outros documentos  primeiro à procura de inválidos
    let otherDocumentsOk: boolean = true;
    let othersDocs = newDocumentList.filter(
      (el: DocumentVMExtension) => el.isMandatoryFile == null ||
        el.isMandatoryFile == null ||
        el.isMandatoryFile?.toString()?.toLowerCase() === 'false'
    );
    if (othersDocs.length > 0) {
      othersDocs.forEach((el: DocumentVMExtension) => {
        if (el.fileID == null || el.fileID == undefined || el.fileID == "0") {
          otherDocumentsOk = false;
        }
      });
    }
    if (!isDocumentsOk && showMessage) {
      var baseModal = <models.BaseModalVM>{ isError: true, message: "Generic.ErrorOnSentToCGADocuments" };
      this.modalService.showModals([baseModal]).subscribe(result => { });
    } else {
      if (!otherDocumentsOk && showMessage) {
        var baseModal = <models.BaseModalVM>{ isError: true, message: "Generic.ErrorDocuments" };
        this.modalService.showModals([baseModal]).subscribe(result => { });
      }
    }
    return isDocumentsOk && otherDocumentsOk;
  }

}
